import { translate } from '@openclassrooms/translations';

export type AuthContextId =
  | 'applicationWelcomeAuthOrigin'
  | 'courseAccess'
  | 'default'
  | 'downloadPdfB2B'
  | 'downloadSyllabus'
  | 'employer'
  | 'invitation'
  | 'requestCallBackAuthOrigin'
  | 'shareCandidate'
  | 'talents'
  | 'contactB2B'
  | 'jobApplication';
export const SIGN_IN_SOURCE = {
  FORM: 'form',
  SOCIAL: 'social',
};

export function getSignInTitle(context: AuthContextId) {
  const subtitle = translate('auth.sign_in.subheading');

  switch (context) {
    case 'requestCallBackAuthOrigin':
      return { title: translate('sign_in.call_back.goal2.page_title'), subtitle };
    case 'applicationWelcomeAuthOrigin':
      return { title: translate('auth.sign_in.title.funnel'), subtitle };
    case 'courseAccess':
      return { title: translate('auth.sign_in.title.course'), subtitle };
    case 'shareCandidate':
    case 'talents':
      return { title: translate('auth.sign_in.title.hire_apprentices'), subtitle };
    case 'employer':
      return { title: translate('auth.sign_in.title.employer_space'), subtitle };
    case 'downloadSyllabus':
      return {
        title: translate('auth.sign_in.title.syllabus'),
        subtitle,
      };
    case 'downloadPdfB2B':
      return {
        title: translate('auth.sign_in.title.business_content'),
        subtitle,
      };
    case 'contactB2B':
      return {
        title: translate('auth.sign_in.title.get_quote_demo'),
        subtitle,
      };
    case 'jobApplication':
      return {
        title: translate('auth.sign_in.title.job_apply'),
        subtitle,
      };
    case 'default':
    case 'invitation':
    default:
      return { title: translate('auth.sign_in.title.global'), subtitle };
  }
}
export function getCheckDetailsTitle(context: AuthContextId) {
  switch (context) {
    case 'downloadSyllabus':
      return {
        title: translate('auth.check.title'),
        subtitle: translate('auth.check.subheading.syllabus'),
      };
    default:
      return {
        title: translate('auth.check.title'),
      };
  }
}

export function getSignUpTitle(context: AuthContextId) {
  if (context === 'invitation') {
    return {
      title: translate('auth.sign_up.sso.join_org.title'),
      subtitle: translate('auth.sign_in.subheading'),
    };
  }

  return {
    title: translate('auth.sign_up.title.global'),
    subtitle: translate('auth.sign_up.subheading.global'),
  };
}
